"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutoSavePricingType = void 0;
const React = __importStar(require("react"));
const base_1 = require("./base");
const __1 = require("../..");
/**
 * An auto-save entity hook that will
 * GET pricing type for a property
 * PUT pricing type for a property
 * @param propertyId The property to work with
 */
const useAutoSavePricingType = (propertyId) => {
    // @ts-ignore https://github.com/microsoft/TypeScript/issues/42790
    const { entityActions } = React.useContext(__1.AppContext);
    const _a = (0, base_1.useAutoSaveEntity)(
    // Selector
    (state) => state.data.pricingType.byPropertyId[propertyId], 
    // Getter
    // @ts-ignore https://github.com/microsoft/TypeScript/issues/42790
    () => entityActions.pricingType.getByPropertyId(propertyId), 
    // Updater
    (nextPricingType) => entityActions.pricingType.upsertByPropertyId(propertyId, nextPricingType), 
    // Getter error triggers
    {
        clear: 'PRICING_TYPE_GET_BY_PROPERTY_ID_REQUEST',
        error: 'PRICING_TYPE_GET_BY_PROPERTY_ID_FAILURE',
    }, 
    // Updater error triggers
    {
        clear: 'PRICING_TYPE_UPSERT_BY_PROPERTY_ID_REQUEST',
        error: 'PRICING_TYPE_UPSERT_BY_PROPERTY_ID_FAILURE',
    }), { entity: pricingType } = _a, rest = __rest(_a, ["entity"]);
    return Object.assign({ pricingType }, rest);
};
exports.useAutoSavePricingType = useAutoSavePricingType;
//# sourceMappingURL=pricingType.js.map